import { Outlet, useLocation } from "react-router-dom";
import Nav from "./NavAdmin";
import Footer from "../shared/Footer";
import { SEO_PATHS } from "./landing/seoPaths";
import "../../styles/landing.css";

function RootLayoutAdmin() {
    const { pathname } = useLocation();
    const underNav = pathname === "/" || SEO_PATHS.includes(pathname);
    return (
        <>
            <Nav />
            <main>
            {/* De landingspagina's schuiven zelf onder de vaste nav; andere pagina's krijgen ruimte */}
            {!underNav && <div className="h-28 sm:h-32" />}
            <Outlet />
            </main>
            <Footer />
        </>
    );
}

export default RootLayoutAdmin;
